import { render, staticRenderFns } from "./reservation_wx.vue?vue&type=template&id=83777eba"
import script from "./reservation_wx.vue?vue&type=script&lang=js"
export * from "./reservation_wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports